export default interface ExcuseReason {
  Code: string,
  Description: string
}
export const ALT_LOA_CODE = 'ALT_LOA'
export const ALT_TERM_CODE = 'ALT_TERM'
export const ALT_OTHER_CODE = 'ALT_OTHER'

export const AlternateExcuseReasons: ExcuseReason[] = [
  { Code: ALT_LOA_CODE, Description: "LOA until end of Period" },
  { Code: ALT_TERM_CODE, Description: "Terminated" },
  { Code: ALT_OTHER_CODE, Description: "Unavailable to Test/Other" }
]

export function IsAltOtherExcuseReason(code: string) {
  if (!code) {
    return false
  }
  if (code === ALT_OTHER_CODE) {
    return true
  }
  return false
}

export function AltReasonDescriptionByCode(code: string): string{
  if(!code){
    return ""
  }
 const ind = AlternateExcuseReasons.findIndex(item => item.Code === code);
 if(ind < 0){
  return ""
 }
 return AlternateExcuseReasons[ind].Description
}

